import { defineAsyncComponent } from 'vue'
const BackgroundJobs = defineAsyncComponent(() => import('./views/index.vue'));

export default [{
  name: 'background.jobs',
  path: '/background-jobs',
  component: BackgroundJobs,

}];